import type { IconProps } from './../../models/icon';

export function WalletIcon({
  width = 24,
  height = 24,
  secondaryColor = 'var(--color-200)',
  className = '',
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={className}
    >
      <path
        fill="#fff"
        d="M22.2859 12.8572H16.2859C15.8125 12.8572 15.4287 13.2409 15.4287 13.7143V17.1429C15.4287 17.6162 15.8125 18 16.2859 18H22.2859C22.7592 18 23.143 17.6162 23.143 17.1429V13.7143C23.143 13.2409 22.7592 12.8572 22.2859 12.8572Z"
      />
      <path
        fill={secondaryColor}
        fillRule="evenodd"
        d="M0.856934 8.57132V21.4285C0.856934 21.8831 1.03755 22.3192 1.35904 22.6406C1.68053 22.9621 2.11656 23.1428 2.57122 23.1428H18.8569C19.3116 23.1428 19.7477 22.9621 20.0691 22.6406C20.3905 22.3192 20.5712 21.8831 20.5712 21.4285V17.9999H16.2855C15.8121 17.9999 15.4284 17.6161 15.4284 17.1428V13.7142C15.4284 13.2408 15.8121 12.857 16.2855 12.857H20.5712V9.42847C20.5712 8.9738 20.3905 8.53778 20.0691 8.21628C19.7477 7.8948 19.3116 7.71418 18.8569 7.71418H17.1426V3.42847H5.99979C3.15948 3.42847 0.856934 5.73101 0.856934 8.57132Z"
        clipRule="evenodd"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.7"
        d="M22.2859 12.8572H16.2859C15.8125 12.8572 15.4287 13.2409 15.4287 13.7143V17.1429C15.4287 17.6162 15.8125 18 16.2859 18H22.2859C22.7592 18 23.143 17.6162 23.143 17.1429V13.7143C23.143 13.2409 22.7592 12.8572 22.2859 12.8572Z"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.7"
        d="M20.5712 17.9999V21.4285C20.5712 21.8831 20.3905 22.3192 20.0691 22.6406C19.7477 22.9621 19.3116 23.1428 18.8569 23.1428H2.57122C2.11656 23.1428 1.68053 22.9621 1.35904 22.6406C1.03755 22.3192 0.856934 21.8831 0.856934 21.4285V8.57132C0.856934 5.73101 3.15948 3.42847 5.99979 3.42847H17.1426V7.71418"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.7"
        d="M20.5714 12.8572V9.42864C20.5714 8.97398 20.3907 8.53795 20.0693 8.21645C19.7479 7.89497 19.3118 7.71436 18.8571 7.71436H17.1429H6"
      />
    </svg>
  );
}
